export default __webpack_public_path__ + "static/videobg-a5a3ae453e367130acb01f91f2fee3fc.png";